import React from 'react';
import { motion } from 'framer-motion';

const PrivacyRadioVerse = () => {
  return (
    <div className="pt-24 pb-20 max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 legal-content">
      <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }}>
        <span className="text-accent-blue font-semibold tracking-wider text-sm uppercase mb-2 block">App Specific Policy</span>
        <h1>RadioVerse Privacy Policy</h1>
        <p className="text-sm border-l-2 border-accent-blue pl-4 mb-8">
          Last Updated: March 2026
        </p>

        <p>
          This document outlines the specific privacy practices for <strong>RadioVerse</strong>, our internet radio player. It serves as an addendum to the general MediaVerse Labs Privacy Policy.
        </p>

        <h2>1. Zero Data Collection</h2>
        <p>
          RadioVerse does not collect, transmit, or store any personal information on our servers. We do not track your listening habits or station preferences.
        </p>

        <h2>2. Local Data Storage</h2>
        <p>
          All data related to RadioVerse is stored entirely locally on your Windows device. This data is stored in your user's AppData directory: <code>%APPDATA%\RadioVerse</code>. This includes:
        </p>
        <ul>
          <li>Favorite stations and custom stream URLs.</li>
          <li>Recent playback history.</li>
          <li>Application settings and audio preferences.</li>
        </ul>

        <h2>3. Network Connections</h2>
        <p>
          RadioVerse only makes network requests necessary for its core functionality:
        </p>
        <ul>
          <li><strong>Streaming:</strong> Connecting directly to the audio stream URLs of the stations you select.</li>
          <li><strong>Station Directory:</strong> Fetching public radio station directories directly from your device.</li>
          <li><strong>Metadata:</strong> Fetching station logos and current "now playing" info from public APIs.</li>
        </ul>

        <h2>4. No Analytics, Telemetry, or Cookies</h2>
        <p>
          There is no telemetry, analytics code, or cookies embedded within RadioVerse. Your usage remains 100% private.
        </p>

        <h2>5. Contact</h2>
        <p>
          For privacy inquiries: <a href="mailto:hello@mediaverselabs.com">hello@mediaverselabs.com</a>
        </p>
      </motion.div>
    </div>
  );
};

export default PrivacyRadioVerse;